import { ITEM_PER_PAGE_OPTIONS } from 'utils/appConstants';
import { LOCAL_STORAGE_KEYS } from 'BaseComponents/HDataTable/constants';
import {
  useCallback, useEffect, useMemo, useState,
} from 'react';


export const useItemsPerPage = ({
  defaultItemsPerPage,
}) => {
  const key = LOCAL_STORAGE_KEYS.TABLE_ITEMS_PER_PAGE;
  const defaultItemsNumPerPage = useMemo(() => (
    defaultItemsPerPage ?? ITEM_PER_PAGE_OPTIONS[1]
  ),
  [defaultItemsPerPage]);
  const [itemsPerPage, updateItemsPerPage] = useState(defaultItemsNumPerPage);

  const getItemsPerPage = useCallback(() => localStorage.getItem(key), [key]);

  const setItemsPerPage = (value) => {
    updateItemsPerPage(value);
    localStorage.setItem(key, value);
  };

  useEffect(() => {
    const cachedNum = getItemsPerPage();
    const num = cachedNum ? Number(cachedNum) : defaultItemsNumPerPage;
    updateItemsPerPage(num);
  }, [getItemsPerPage, defaultItemsNumPerPage]);


  return {
    itemsPerPage,
    getItemsPerPage,
    setItemsPerPage,
  };
};
